import PropTypes from "prop-types"
import React from "react"
import { Link as ReachLink } from "gatsby"

import {
  Flex,
  Stack,
  Box,
  Text,
  Link,
  Center,
  Spacer,
} from "@chakra-ui/react"

const LinkItem = ({ children, isLast, to = "/", ...rest }) => {
  return (
    <Link as={ReachLink} to={to} style={{ boxShadow: "none" }}>
      <Text display="block" {...rest}>
        {children}
      </Text>
    </Link>
  )
}
const MenuLinks = () => (
  <Box
    display={{ base: "block", md: "block" }}
    flexBasis={{ base: "100%", md: "auto" }}
  >
    <Stack
      spacing={8}
      align="center"
      justify={["center", "space-between", "flex-end", "flex-end"]}
      direction={["column", "row", "row", "row"]}
      pt={[4, 4, 0, 0]}
    >
      <LinkItem to="#tarifs">Nos tarifs</LinkItem>
      <LinkItem to="#horaires">Nos horaires</LinkItem>
      <LinkItem to="#retrouvez">Nous retrouver</LinkItem>
    </Stack>
  </Box>
)
const NavBarContainer = ({ children, ...props }) => {
  return (
    <Flex
      as="nav"
      justify="space-around"
      wrap="wrap"
      w="100%"
      mb={4}
      p={2}
      bg={["primary.500", "primary.500", "transparent", "transparent"]}
      align="stretch"
      {...props}
    >
      {children}
    </Flex>
  )
}
const Header = ({ metadata }) => {

  return (
    <header>
      <Flex justifyContent="center" flexDirection="column" h="100vh" bg="black">
        <Spacer />
        <Box>
          <Center fontSize="5xl" color="primary" as="i" fontWeight="bold">
            {metadata.title}
          </Center>
          <Center fontSize="2xl" color="white">
            {metadata.phone}
          </Center>
          <Center fontSize="2xl" color="white">
            {metadata.address}
          </Center>
        </Box>
        <Spacer />
        <NavBarContainer color="white" fontWeight="bold" >
          <MenuLinks />
        </NavBarContainer>
      </Flex>
    </header>
  )
}
Header.propTypes = {
  siteTitle: PropTypes.string,
}
Header.defaultProps = {
  siteTitle: ``,
}
export default Header
